import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-10 px-4 bg-[#fdfbf7] border-t border-gray-100" data-id="element-170">
      <div className="max-w-4xl mx-auto text-center" data-id="element-171">
        <div className="inline-flex items-center justify-center p-3 bg-purple-100 rounded-full mb-4" data-id="element-172">
          <SparklesIcon className="h-6 w-6 text-purple-600" data-id="element-173" />
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 font-heading" data-id="element-174">
          Presentamos:{' '}
          <span className="text-purple-700" data-id="element-175">
            EL CÓDIGO DEL METABOLISMO SILENCIOSO
          </span>
        </h2>

        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-176">
          Un protocolo diseñado específicamente para la mujer latina que vive
          bajo el estrés de USA.
        </p>

        <div className="grid md:grid-cols-3 gap-8 text-left max-w-5xl mx-auto" data-id="element-177">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-178">
            <div className="text-4xl mb-4" data-id="element-179">🌿</div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-180">
              100% Natural
            </h3>
            <p className="text-gray-600" data-id="element-181">
              Sin ingredientes raros, sin pastillas mágicas y sin químicos que
              alteren tu cuerpo.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-182">
            <div className="text-4xl mb-4" data-id="element-183">💰</div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-184">Económico</h3>
            <p className="text-gray-600" data-id="element-185">
              Sin suplementos costosos de $100 dólares. Todo lo que necesitas ya
              está en tu cocina.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-186">
            <div className="text-4xl mb-4" data-id="element-187">🍽️</div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-188">Sin Hambre</h3>
            <p className="text-gray-600" data-id="element-189">
              Olvídate de contar calorías obsesivamente. Aprende a nutrirte, no
              a privarte.
            </p>
          </div>
        </div>

        <div className="mt-10 bg-purple-900 text-white p-10 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-190">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-purple-700 rounded-full opacity-50 blur-3xl" data-id="element-191"></div>
          <div className="absolute bottom-0 left-0 -mb-10 -ml-10 w-40 h-40 bg-purple-500 rounded-full opacity-50 blur-3xl" data-id="element-192"></div>

          <div className="relative z-10" data-id="element-193">
            <h3 className="text-2xl md:text-3xl font-bold mb-6 font-heading" data-id="element-194">
              El Secreto: La "Ventana Térmica Nocturna"
            </h3>
            <p className="text-lg text-purple-100 max-w-3xl mx-auto leading-relaxed" data-id="element-195">
              Aprenderás 3 pasos simples antes de dormir para bajar tus niveles
              de cortisol y obligar a tu cuerpo a usar la grasa abdominal como
              combustible mientras descansas profundamente.
            </p>
          </div>
        </div>
      </div>
    </section>;
}